var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { jsxs, jsx, Fragment } from "react/jsx-runtime";
import React__default from "react";
import "../Pickers.js";
import "../Checkbox/index.js";
import "../Stack.js";
import "../Icon/index.js";
import "../Label/index.js";
import "../Dropdown/index.js";
import { AsyncRequestStatus } from "@ane/core/lib/models/IAsyncWrapper/IAsyncWrapper";
import "../Loading.js";
import "../Text.js";
import "../../Styling.js";
import { getSubscriberPickerClassNames } from "./SubscriberPicker.classNames.js";
import "../Persona.js";
import "../Callout/index.js";
import { getTheme } from "@fluentui/style-utilities";
import { Stack } from "../Stack/Stack.js";
import { Label } from "../Label/Label.js";
import { Icon } from "../Icon/Icon.js";
import { StackItem } from "../Stack/StackItem.js";
import { NormalPeoplePicker as NormalPeoplePicker$1, ValidationState, PeoplePickerItem } from "@fluentui/react/lib/Pickers";
import { Loading } from "../Loading/Loading.js";
import { Checkbox } from "../Checkbox/Checkbox.js";
import { Dropdown } from "../Dropdown/Dropdown.js";
import { Text } from "@fluentui/react/lib/Text";
import { PersonaPresence, Persona, PersonaSize } from "@fluentui/react/lib/Persona";
import { WithCallout } from "../Callout/WithCallout.js";
const theme = getTheme();
class SubscriberPicker extends React__default.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "renderItem", (props) => {
      const item = __spreadProps(__spreadValues({}, props.item), {
        ValidationState: ValidationState.valid,
        presence: PersonaPresence.none
      });
      const defaultProps = __spreadProps(__spreadValues({}, props), {
        item
      });
      const disabled = item.disabled;
      return /* @__PURE__ */ jsx(
        WithCallout,
        {
          preventAutoTabIndex: true,
          calloutProps: {
            content: /* @__PURE__ */ jsx(Persona, __spreadProps(__spreadValues({}, item), { size: PersonaSize.size72, presence: PersonaPresence.none }))
          },
          children: /* @__PURE__ */ jsx(PeoplePickerItem, __spreadProps(__spreadValues({}, defaultProps), { disabled }))
        },
        item.text
      );
    });
  }
  render() {
    const {
      styles,
      ariaLabel,
      peoplePickerProps,
      labelProps,
      iconProps,
      dropdownProps,
      checkboxProps,
      loadingProps,
      required,
      isReadOnly,
      errorMessage
    } = this.props;
    const _a = peoplePickerProps, { onRenderItem = this.renderItem } = _a, restPeoplePickerProps = __objRest(_a, ["onRenderItem"]);
    const classNames = getSubscriberPickerClassNames(theme, styles);
    const isLoading = (loadingProps == null ? void 0 : loadingProps.status) === AsyncRequestStatus.Pending;
    const isLoadCompelted = (loadingProps == null ? void 0 : loadingProps.status) === AsyncRequestStatus.Completed;
    return /* @__PURE__ */ jsxs(Stack, { className: classNames.root, children: [
      /* @__PURE__ */ jsxs(Stack, { horizontal: true, horizontalAlign: "start", children: [
        !!labelProps ? /* @__PURE__ */ jsx(Label, __spreadProps(__spreadValues({}, labelProps), { required, disabled: isReadOnly })) : /* @__PURE__ */ jsx(Fragment, {}),
        !!iconProps ? /* @__PURE__ */ jsx(Icon, __spreadValues({}, iconProps)) : /* @__PURE__ */ jsx(Fragment, {})
      ] }),
      /* @__PURE__ */ jsxs(Stack, { horizontal: true, children: [
        /* @__PURE__ */ jsx(StackItem, { grow: 10, children: /* @__PURE__ */ jsxs(Stack, { tokens: { childrenGap: 10 }, className: classNames.fieldContainer, children: [
          /* @__PURE__ */ jsx(
            NormalPeoplePicker$1,
            __spreadProps(__spreadValues({}, restPeoplePickerProps), {
              "aria-label": ariaLabel,
              disabled: isReadOnly || isLoading,
              onRenderItem
            })
          ),
          !!loadingProps ? /* @__PURE__ */ jsx(StackItem, { className: classNames.loadingContainer, children: /* @__PURE__ */ jsx(Loading, __spreadValues({}, loadingProps)) }) : /* @__PURE__ */ jsx(Fragment, {}),
          !!checkboxProps && isLoadCompelted ? /* @__PURE__ */ jsx(StackItem, { className: classNames.checkboxContainer, children: /* @__PURE__ */ jsx(Checkbox, __spreadValues({}, checkboxProps)) }) : /* @__PURE__ */ jsx(Fragment, {})
        ] }) }),
        /* @__PURE__ */ jsx(StackItem, { children: !!dropdownProps && !isLoading ? /* @__PURE__ */ jsx(Dropdown, __spreadProps(__spreadValues({}, dropdownProps), { disabled: isReadOnly })) : /* @__PURE__ */ jsx(Fragment, {}) })
      ] }),
      !!errorMessage ? /* @__PURE__ */ jsx(Stack, { horizontal: true, horizontalAlign: "start", children: /* @__PURE__ */ jsx(Text, { role: "alert", className: classNames.errorText, children: errorMessage }) }) : /* @__PURE__ */ jsx(Fragment, {})
    ] });
  }
}
export {
  SubscriberPicker
};
//# sourceMappingURL=SubscriberPicker.js.map
